import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppTopBar } from "@/components/AppTopBar";

export default function MasterToko() {
  const { user } = useAuth();
  const [stores, setStores] = useState([]);
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  const load = () => api.get("/stores").then(({ data }) => setStores(data)).catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail)));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault(); setError(""); setNotice("");
    if (!name.trim()) { setError("Nama toko wajib diisi."); return; }
    try {
      await api.post("/stores", { name: name.trim() });
      setNotice(`Toko "${name.trim()}" ditambahkan.`); setName(""); load();
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };

  const toggle = async (s) => {
    setError(""); setNotice("");
    try {
      await api.patch(`/stores/${s.id}`, { status: s.status === "ACTIVE" ? "INACTIVE" : "ACTIVE" });
      load();
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };

  if (user && user.role !== "OWNER") {
    return (<div className="app-shell"><AppTopBar active="stores" /><main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main></div>);
  }

  return (
    <div className="app-shell">
      <AppTopBar active="stores" />
      <main className="content">
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}
        {notice && <div className="alert-ok" data-testid="notice-banner">{notice}</div>}

        <section className="panel" data-testid="store-create-panel">
          <h2 className="panel-title">Master Toko</h2>
          <form onSubmit={create} style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 260 }}>
              <label className="field-label">Nama Toko</label>
              <input className="field-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Contoh: Jayerindo Official Store" data-testid="store-name-input" />
            </div>
            <button className="btn-primary inline" type="submit" data-testid="store-create-button">+ Tambah Toko</button>
          </form>
        </section>

        <section className="panel" data-testid="store-list-panel">
          <h2 className="panel-title">Daftar Toko ({stores.length})</h2>
          <div className="table-scroll">
            <table className="data-table" data-testid="store-table">
              <thead><tr><th>Nama Toko</th><th>Status</th><th>Aksi</th></tr></thead>
              <tbody>
                {stores.length === 0 && <tr><td colSpan={3} className="empty-cell">Belum ada toko.</td></tr>}
                {stores.map((s) => (
                  <tr key={s.id} data-testid={`store-row-${s.id}`}>
                    <td>{s.name}</td>
                    <td><span className={`status-pill ${s.status === "ACTIVE" ? "on" : "off"}`} data-testid={`store-status-${s.id}`}>{s.status}</span></td>
                    <td><button className="btn-mini" onClick={() => toggle(s)} data-testid={`store-toggle-${s.id}`}>{s.status === "ACTIVE" ? "Nonaktifkan" : "Aktifkan"}</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
